import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { TranslationContext } from "../contexts/TranslationContext";

const MobileLandscapePage = () => {
  const { translations } = useContext(TranslationContext);

  return (
    <>
      <div
        className="landscape-wrapper text-center"
        style={{ top: "0%" }}
      > 
        <div className="container-fluid">
          <div className="text-center mb-4">
            <Link
              to="/"
              className="d-block m-auto pt-3"
              style={{ width: "60%" }}
            >
              <img
                src="../images/oavlite-black.png"
                className="img-fluid mx-auto text-center d-block d-logo mb-2"
                alt="oavlite"
              />
            </Link>
            <p className="mb-0 taglineV1 fw-500">
              {translations.taglineV1}
            </p>
          </div>
          <div className="center-content">
            <h6 className="color-primary mb-2 tagline__2 ">UN RÉSEAU SOCIAL UNIQUE</h6> 
            <h6
              className="mb-2 bgprimary px-4 px-md-5 py-2 tagline__4"
              style={{ width: "max-content", margin: "auto" }}
            >
             SITE ACCESSIBLE UNIQUEMENT SUR ORDINATEUR
            </h6>
            <h5 className="color-primary mb-3 tagline__5" >
              REJOIGNEZ-NOUS OAVLITE.COM
            </h5>
            <Link
              to="/se-connecter" 
              className="oavlite-text-primary bgprimary mb-0 fw-600 d-block badge-light bg-white p-3 px-md-5 rounded-pill tagline-badge mb-2 tagline__6"
            >
             TAPER OAVLITE.COM DANS VOTRE BARRE DE RECHERCHE SUR VOTRE ORDINATEUR POUR VOUS CONNECTER ET VOUS INSCRIRE
            </Link>
          
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileLandscapePage;
